import { createEnumParam, useQueryParam, withDefault } from "use-query-params";

import {
  type ITimeGranularityV2,
  TimeGranularityV2,
} from "@north-beam/nb-common";

export const TimeGranularityQueryParam = createEnumParam<ITimeGranularityV2>(
  TimeGranularityV2.keyOrder,
);

export const useTimeGranularityQueryParams = () => {
  const [timeGranularity, setTimeGranularity] =
    useQueryParam<ITimeGranularityV2>(
      "timeGranularity",
      withDefault(TimeGranularityQueryParam, "daily"),
      {
        updateType: "pushIn",
      },
    );

  return { timeGranularity, setTimeGranularity };
};
